import Leaflet from "leaflet";
import markerIcon2x from "leaflet/dist/images/marker-icon-2x.png";
import markerIcon from "leaflet/dist/images/marker-icon.png";
import markerShadow from "leaflet/dist/images/marker-shadow.png";
import "leaflet/dist/leaflet.css";
import { useEffect, useState } from "react";
import { MapContainer, TileLayer } from "react-leaflet";
import { filterPointsOfSale } from "../../../common/services/externalService";
import PointsOfSaleCustomMap from "./points-of-sale-custom-map/points-of-sale-custom-map";

delete Leaflet.Icon.Default.prototype._getIconUrl; //INFO: workaround for https://github.com/PaulLeCam/react-leaflet/issues/967
Leaflet.Icon.Default.mergeOptions({
  iconUrl: markerIcon,
  iconRetinaUrl: markerIcon2x,
  shadowUrl: markerShadow,
});

export const WARSAW_COORDS = [52.2297, 21.0122];

function PointsOfSaleMap({ selectedOfferFilter, mapSiteConfigKey }) {
  const [pointsOfSale, setPointsOfSale] = useState([]);
  const [viewBounds, setViewBounds] = useState(null);

  useEffect(() => {
    if (viewBounds) {
      filterPointsOfSale(
        mapSiteConfigKey,
        selectedOfferFilter ?? null,
        viewBounds.getNorthEast().lng,
        viewBounds.getNorthEast().lat,
        viewBounds.getSouthWest().lng,
        viewBounds.getSouthWest().lat
      )
        .then((response) => {
          const posList = response.data.pointsOfSale.map((pos) => {
            return { ...pos, position: [pos.y_st, pos.x_st] };
          });
          setPointsOfSale(posList);
        })
        .catch((err) => {
          console.error(err);
        });
    }
  }, [mapSiteConfigKey, selectedOfferFilter, viewBounds]);

  return (
    <MapContainer
      style={{
        height: "90%",
        width: "100%",
      }}
      center={WARSAW_COORDS}
      zoom={11}
      scrollWheelZoom={true}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <PointsOfSaleCustomMap pointsOfSale={pointsOfSale} setViewBounds={setViewBounds} />
    </MapContainer>
  );
}
export default PointsOfSaleMap;
